import FaqList from './faq-list';

export default FaqList;
export {FaqList};